import { getAppConfig } from "../utils/appConfig";

const baseTheme = {
  fonts: {
    primary: "'AlbertSans', sans-serif",
    primaryExtraBold: "'AlbertSansExtraBold', sans-serif",
    primaryPoppins: "'Poppins', sans-serif",
    primaryInter: "'Inter', sans-serif",
  },
  navBarHeightPx: "88",
  colors: {
    gray: "#5A5A5A",
    gray_o40: "#5A5A5A66",
    gray2: "#656565",
    gray2_disabled: "#9B9B9B",
    black: "#000000",
    black_o70: "#000000b3",
    white: "#ffffff",
    red: "#F95959",
    red_disabled: "#F95959BF",
    green: "#6C8A2C",
    success: "#28a745",
    saturated_purple: "#471168",
    btn_border_color: "#757678",
    background_color: "#ebebeb",
    candidate_table_head_color: "#F0F0EFC2",
    candidate_table_head_color2: "#E9E9E9C2",
    divider_color: "#CDCDCD",
    rateCard_border_color: "#CECECE",
  },
};

export const getTheme = () => {
  const appConfig = getAppConfig();

  const appTypeInfo = {};

  if (appConfig.theme.isSalesstream) {
    appTypeInfo.isSalesstream = appConfig.theme.isSalesstream;
  }

  if (appConfig.theme.isReachthepeople) {
    appTypeInfo.isReachthepeople = appConfig.theme.isReachthepeople;
  }

  return {
    ...baseTheme,
    ...appTypeInfo,
    logoPath: appConfig.theme.logoPath,
    miniLogoPath: appConfig.theme.miniLogoPath,
    authBg: appConfig.theme.authBg,
    showPasswordIconPath: appConfig.theme.showPasswordIconPath,
    hidePasswordIconPath: appConfig.theme.hidePasswordIconPath, 
    primaryTextColor: appConfig.theme.primaryTextColor,
    secondaryTextColor: appConfig.theme.secondaryTextColor,
    tertiaryTextColor: appConfig.theme.tertiaryTextColor,
    accentTextColor: appConfig.theme.accentTextColor,
    primaryFontWeight: appConfig.theme.primaryFontWeight,
    secondaryFontWeight: appConfig.theme.secondaryFontWeight,
    primaryBorderRadius: appConfig.theme.primaryBorderRadius,
    fonts: {
      ...baseTheme.fonts,
      ...appConfig.theme.fonts,
    },
    colors: {
      ...baseTheme.colors,
      ...appConfig.theme.colors,
    },
    borderRadius: {
      ...baseTheme.borderRadius,
      ...appConfig.theme.borderRadius,
    },
    buttonVariants: {
      ...baseTheme?.buttonVariants,
      ...appConfig.theme.buttonVariants,
    },
    separatorVariants: {
      ...baseTheme?.separatorVariants,
      ...appConfig.theme.separatorVariants,
    },
    filterVariants: {
      ...baseTheme?.filterVariants,
      ...appConfig.theme.filterVariants,
    },
    inputLabel: {
      ...baseTheme?.inputLabel,
      ...appConfig.theme.inputLabel,
    },
    input: {
      ...baseTheme?.input,
      ...appConfig.theme.input,
    },
    titleVariants: {
      ...baseTheme?.titleVariants,
      ...appConfig.theme.titleVariants,
    },
    chat: {
      ...baseTheme?.chat,
      ...appConfig.theme.chat,
    },
    table: {
      ...baseTheme?.table,
      ...appConfig.theme.table,
    },
    toggle: {
      ...baseTheme?.toggle,
      ...appConfig.theme.toggle,
    },
  };
};
